export default {
  _keys: {},
  install (Vue) {
    // eslint-disable-next-line
    const _KeyUpListener = this
    Vue.directive('jtkey-up', {
      bind: function (el, binding) {
        const idKeyUp = new Date().getTime()
        el._idKeyUp = idKeyUp
        _KeyUpListener.add(idKeyUp, binding.arg, binding.value)
      },
      unbind: function (el, binding) {
        _KeyUpListener.drop(el._idKeyUp, binding.arg)
      }
    })
    window.addEventListener('keyup', function (event) {
      if (_KeyUpListener._keys[event.key]) {
        _KeyUpListener._keys[event.key].forEach(i => {
          i.funct(event, i)
        })
      }
    })
  },
  add: function (id, key, funct) {
    if (!this._keys[key]) this._keys[key] = []
    this._keys[key].push({ id: id, key: key, funct: funct })
  },
  drop: function (id, key) {
    this._keys[key].splice(
      this._keys[key].findIndex(i => i.id === id),
      1
    )
  }
}
